export const dateToString = (aDate, format = 'YMD') => {
  let dateStr = null
  if (aDate) {
    const { dayValue, monthValue, yearValue } = aDate
    if (dayValue && monthValue && yearValue) {
      switch (format) {
        case 'MDY':
          // Convert 3 date values into a MM/DD/YYYY.
          dateStr = `${monthValue}/${dayValue}/${yearValue}`
          break
        case 'DMY':
          // Convert 3 date values into a DD/MM/YYYY.
          dateStr = `${dayValue}/${monthValue}/${yearValue}`
          break
        case 'YMD':
        default:
          // Convert 3 date values into a YYYY-MM-DD string.
          dateStr = `${yearValue}-${monthValue}-${dayValue}`
      }
    }
  }
  return dateStr
}
